import { c as _c } from "react/compiler-runtime";
import { EventReadAddress, EventReadDate, EventReadTime } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/header/";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventReadHeaderProps {
  event: EventRead;
}
export const EventReadHeader: React.FC<EventReadHeaderProps> = t0 => {
  const $ = _c(7);
  const {
    event
  } = t0;
  let t1;
  if ($[0] !== event) {
    t1 = <div className="flex flex-col gap-2 mb-2 w-full md:w-1/2"><EventReadDate event={event} /><EventReadTime event={event} /></div>;
    $[0] = event;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== event) {
    t2 = <div className="flex w-full md:w-1/2"><EventReadAddress event={event} /></div>;
    $[2] = event;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col"><div className="flex flex-col md:flex-row justify-between items-start">{t1}{t2}</div></div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};